import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles(theme => ({
marker: {
  cursor: "pointer",
  width:"50px",
  height:"80px",
  top:"-80px",
  left:"-25px",
  position:"relative"
}
}))

export default style;
